export const CustomKeys = Object.freeze(
    {
        governing_organizations: {
            name: 'governing-organizations',
            label: 'governing organizations',
            path: '/governing-organizations',
        },
        subordinate_units: {
            name: 'subordinate-units',
            label: 'subordinate units',
            path: '/subordinate-units',
        },
        add_host: {
            name: 'add-host',
            label: 'add-host',
            path: '/add-host',
        },
        edit_owner: {
            name: 'edit-owner',
            label: 'edit-owner',
            path: '/edit-owner',
        },
    }
)

export const fromCustomKeys = (key) => {
    switch (key) {
        case CustomKeys.governing_organizations:
            return {}
        default:
            return {}
    }
}
